module.exports = __webpack_public_path__ + "img/protected-icon.1be859f7.svg";